import React from 'react';
import styled from 'styled-components';

const ProgressBarContainer = styled.div`
	position: relative;
	width: 100%;

	padding-bottom: 12px;

	@media screen and (min-width: 960px) {
		padding-bottom: 16px;
	}
`;

const ProgressBarBase = styled.div`
	position: absolute;
	width: 100%;
	height: 12px;

	background-color: #000e26;
	border-radius: 16px;
	opacity: 0.5;

	@media screen and (min-width: 960px) {
		height: 16px;
	}
`;

const ProgressBarContent = styled.div<{ progress: number; gradientColor: string }>`
	position: absolute;
	width: ${(props) => props.progress}%;
	height: 12px;

	border-radius: 16px;
	background: ${(props) => props.gradientColor};

	transition: width 0.5s ease-out;

	@media screen and (min-width: 960px) {
		height: 16px;
	}
`;

export const DataCollectionProgressBar = ({
	progress,
	gradientColor,
}: {
	progress: number;
	gradientColor: string;
}): React.ReactElement => {
	return (
		<ProgressBarContainer className="progress-bar__container">
			<ProgressBarBase className="progress-bar__base" />
			<ProgressBarContent className="progress-bar__content" progress={progress} gradientColor={gradientColor} />
		</ProgressBarContainer>
	);
};
